<script>
    let email;
    let password;

    export let callback;

    let pw_error = false;
    let email_error = false;

    let login_data = {
        "email" : "test@test.com",
        "pw" : "test1234"
    }

    let checkLogin = () => {
        if (email && password) {
            // (Fetch with login details)
            let auth = {
                'email' : email,
                'password' : password
            }
            auth = JSON.stringify(auth)

            // Static authentication
            if (email === login_data['email'] && password === login_data['pw']) {
                window.location.href = "/cards";
                email = password = "";
            }
        }
        else {
            if (!email) {
                email_error = true;
            }
            if (!password) {
                pw_error = true;
            }
        }
    }


</script>

<div class="login_container">

    <div class="login_wrapper">

        <div class="logo">

            <img src="assets/svgs/logo.svg" alt="">

        </div>

        <div class="inputs">

            <div class="input_container">
                <input bind:value={email} type="email" placeholder="Email address">
                {#if email_error}
                    <span class="login_error">Email Address is required</span>
                {/if}
            </div>

            <div class="input_container">
                <input bind:value={password} type="password" placeholder="Password"/>
                {#if pw_error}
                    <span class="login_error">Password is required</span>
                {/if}
            </div>



        </div>

        <div class="btn-container">

            <button class="btn" on:click={checkLogin}>Login</button>

        </div>

        <div class="register_forgot">

            <span on:click={callback}>Register</span>
            <a href="/password">Forgot password?</a>

        </div>

    </div>

</div>

<style>

    .login_container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .login_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 80%;
        justify-content: space-between;
    }
    .logo {

    }
    .logo img {

    }
    .inputs input {
        text-align: center;
        width: 100%;
        padding: 2vw 0;
    }
    .login_error {
        position: absolute;
        top: 101%;
        left: 0;
        color: red;
    }

    .register_forgot {
        margin-top: 15vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .register_forgot a {
        text-align: center;
        color: black;
    }
    .register_forgot span {
        text-align: center;
        color: black;
        margin-bottom: 3vw;
    }

</style>